<template>
    <ion-row>
        <ion-col size-xs="12">
            <ion-card style="margin-bottom: 0; margin-top: 5px;">
                <ion-card-header>
                    <ion-card-title>{{ $t('ncrypt.covid_passport.dashboard.title') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content style="padding-top: 5px;">
                    <ion-text>{{ $t('ncrypt.covid_passport.dashboard.intro') }}</ion-text>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</template>

<script>
    export default {
        name: "CovidPassportDashboardHeader",
        props: {
            entries: {type: Array},
        },
    }
</script>
